const TextButton = ({ onClick, children }) => {
  return (
    <button onClick={onClick} className="hover:text-primary-400 animate-all duration-100">
      {children}
    </button>
  );
};

export default TextButton;
